import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-workshop-success-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './workshop-success-modal.component.html',
  styleUrl: './workshop-success-modal.component.scss'
})
export class WorkshopSuccessModalComponent {
  // Inputs to make the popup dynamic and reusable
  @Input() isVisible: boolean = false;
  @Input() referenceId: string = 'WK-2026-1048';
  @Input() userEmail: string = 'jay@xyzcollege.edu';
  @Input() expectedResponse: string = 'Within 3 business days';

  // Output event to handle close trigger in parent component
  @Output() closeModal = new EventEmitter<void>();

  onClose() {
    this.closeModal.emit();
  }
}
